import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import { MessagesService } from '@appStore/account/services/messages.service';
import { ActionTypes } from '@appStore/account/actions';
import * as actions from '@appStore/account/actions';

@Injectable()
export class MessagesEffects {
  constructor(private messagesService: MessagesService, private actions$: Actions) {}

  loadMessages$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.MessageLoadData),
      exhaustMap(action => {
        return this.messagesService.getMyMessages().pipe(
          map(messages => new actions.MessageLoadSuccess(messages)),
          catchError(error => of(new actions.MessageLoadFail(error)))
        );
      })
    );
  });

  loadUnreadMessagesCount$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.MessageLoadCount),
      exhaustMap(action => {
        return this.messagesService.getMyUnreadMessagesCount().pipe(
          map(count => {
            return new actions.MessageLoadCountSuccess(count);
          }),
          catchError(error => of(new actions.MessageLoadCountFail(error)))
        );
      })
    );
  });

  setMessageAsRead$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.MessageSetAsRead),
      map((action: actions.MessageSetAsRead) => action.payload),
      exhaustMap(message => {
        return this.messagesService.setMessageAsRead(message).pipe(
          map(updatedItem => new actions.MessageSetAsReadSuccess(updatedItem)),
          catchError(error => of(new actions.MessageSetAsReadFail(error)))
        );
      })
    );
  });
}
